// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_PlanPriceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_PlanPriceInput — body for POST /subscriptions/plans/{id}/prices.
 *
 * Upserts one live price row for a (plan, currency, provider_code) tuple.
 * Second call for the same (plan, currency, provider_code) versions the
 * existing row (createPrice or versionPrice depending on whether a live row exists).
 *
 * Required:
 *   currency      (string)   ISO 4217 uppercase; e.g. 'BRL', 'USD', 'CLP'
 *   provider_code (string)   Gateway code; must be registered in PlatformGatewayRegistry
 *   price_cents   (int)      Price in cents; must be > 0
 *   countries     (string[]) Non-empty list of ISO 3166-1 alpha-2 country codes
 *
 * NOT accepted:
 *   provider_price_ref — SERVER-MINTED (2026-08-21). For a gateway that declares
 *                        GatewayCapabilities::OP_EXTERNAL_PRICE_CATALOG the
 *                        controller creates the price at the gateway and writes
 *                        the reference back; for every other gateway there is no
 *                        reference to hold. Sending one is refused either way.
 */
import { registerContract } from './validate'

export interface Subscriptions_PlanPriceInput {
currency: string
provider_code: string
price_cents: number
countries: string[]
provider_price_ref?: string
}

registerContract('Subscriptions_PlanPriceInput', {
  currency:           { type: 'string',  required: true },
  provider_code:      { type: 'string',  required: true },
  price_cents:        { type: 'number',  required: true },
  countries:          { type: 'array',   required: true },
  provider_price_ref: { type: 'string',  required: false },
})
